import { FC, memo } from 'react';

import V2SalesOrdersPresenter from './V2SalesOrdersPresenter';

const V2SalesOrders: FC = memo(() => <V2SalesOrdersPresenter />);

export default V2SalesOrders;
